<template>
  <div v-if="unit">
    <div id="unitContentWrapper" class="kt-portlet kt-portlet--height-fluid">
      <div
        class="kt-portlet__head kt-portlet__head kt-portlet__head--lg kt-portlet__head--noborder kt-portlet__head--break-sm"
      >
        <div
          class="kt-portlet__head-label flex-column justify-center align-baseline pt-4"
          style="width: 100%"
        >
          <h3 id="unitTitle" class="kt-portlet__head-title" v-if="!editTitle">
            <span
              v-if="unit.module"
              @click="goToModule(unit.module.id)"
              class="text-warning pointer"
              >{{ unit.module.name }}:
            </span>
            <span v-else class="text-warning"> Uncategorized: </span>
            <v-tooltip top v-if="canEdit(unit.author.dealer_id)">
              <template #activator="{ on }">
                <v-btn
                  x-small
                  elevation="0"
                  v-on="on"
                  color="#f9b418"
                  @click="toggleAddToLibraryDialog"
                >
                  <i class="fa fa-pencil mr-1" /> Edit
                </v-btn>
              </template>
              <span> Click to Edit Library Assignment </span>
            </v-tooltip>
            <span>
              {{ unit.name }}
              <v-tooltip top v-if="canEdit(unit.author.dealer_id)">
                <template #activator="{ on }">
                  <v-btn
                    x-small
                    elevation="0"
                    v-on="on"
                    color="#f9b418"
                    @click="toggleEditTitle"
                  >
                    <i class="fa fa-pencil mr-1" /> Edit
                  </v-btn>
                </template>
                <span> Click to Edit Title </span>
              </v-tooltip>
            </span>
          </h3>
          <template v-if="editTitle">
            <v-row class="w-100">
              <v-text-field
                label="Edit Title"
                single-line
                v-model="unit.name"
              ></v-text-field>
            </v-row>
            <v-row justify="end" class="w-100 text-right">
              <v-btn
                :loading="isLoading"
                :disabled="isLoading"
                x-small
                color="success"
                class="ml-1"
                @click="quickUpdate"
              >
                Save
              </v-btn>
              <v-btn
                :loading="isLoading"
                :disabled="isLoading"
                x-small
                class="ml-1"
                @click="toggleEditTitle"
              >
                cancel
              </v-btn>
            </v-row>
          </template>
          <h5 v-if="unit.is_draft" class="mt-1">Status: Draft</h5>
          <h5 v-else class="mt-1">
            Status: {{ isCompleted ? 'Completed' : 'Open' }}
          </h5>
          <!--          <v-switch-->
          <!--            v-if="canEdit(unit.author.dealer_id)"-->
          <!--            v-model="unit.is_draft"-->
          <!--            :label="`Draft`"-->
          <!--            :disabled="isLoading"-->
          <!--            :loading="isLoading"-->
          <!--          ></v-switch>-->
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="d-flex" v-if="unit.series">
          <v-btn
            text
            class="mr-3"
            :loading="loadingMark"
            color="blue-grey darken-1"
            @click="previous"
          >
            <v-icon class="mr-2">fal fa-backward</v-icon>
            Prev
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            text
            class="ml-3"
            :loading="loadingMark"
            color="blue-grey darken-1"
            @click="next"
          >
            Next
            <v-icon class="ml-2">fal fa-forward</v-icon>
          </v-btn>
        </div>
        <div v-if="unit.is_stream">
          <iframe
            :src="unit.content_file"
            style="width: 100%; height: 800px"
          ></iframe>
        </div>
        <div v-if="unit.is_download" class="text-center">
          Click
          <a :href="unit.content_file" download target="_blank">HERE</a> to
          download material
        </div>
        <div class="video-wrapper text-center mt-3">
          <div id="unit-page__unit-desc">
            <div
              class="mx-auto embed-container"
              id="unit-content"
              v-html="contents"
              :class="isAVideoTypeUnit ? 'embed-padding-bottom' : ''"
            />
            <div class="text-center mt-3 mod-tag">
              <template v-if="!editTags">
                <span>Tags:</span>
                <v-chip
                  class="ml-1 grey lighten-3 mt-2"
                  small
                  v-for="tag in tags"
                  v-bind:key="tag.id"
                  >{{ tag.name }}</v-chip
                >
                <v-tooltip top v-if="canEdit(unit.author.dealer_id)">
                  <template #activator="{ on }">
                    <v-btn
                      x-small
                      elevation="0"
                      v-on="on"
                      color="#f9b418"
                      @click="toggleEditTags"
                    >
                      <span v-if="unit.tags.length !== 0">
                        <i class="fa fa-pencil mr-1" /> Edit
                      </span>
                      <span v-else>Add Tags</span>
                    </v-btn>
                  </template>
                  <span> Click to Edit Tags </span>
                </v-tooltip>
              </template>
              <template v-else>
                <v-combobox
                  v-model="unit.tags"
                  label="Tags"
                  name="tags"
                  :items="loadTags"
                  :item-text="(item) => item.name"
                  :item-value="(item) => item.id"
                  multiple
                  chips
                  prepend-icon="fal fa-tags"
                  :menu-props="{ closeOnClick: true }"
                ></v-combobox>
                <div class="mt-2">
                  <v-btn
                    :loading="isLoading"
                    :disabled="isLoading"
                    x-small
                    color="success"
                    class="ml-1"
                    @click="quickUpdate"
                  >
                    Save
                  </v-btn>
                  <v-btn
                    :loading="isLoading"
                    :disabled="isLoading"
                    x-small
                    class="ml-1"
                    @click="toggleEditTags"
                  >
                    cancel
                  </v-btn>
                </div>
                .
              </template>
            </div>
            <div class="text-center mt-3 w-75 p-3 description">
              <p v-if="!editDescription">
                <span v-html="unit.description"></span>
                <v-tooltip top v-if="canEdit(unit.author.dealer_id)">
                  <template #activator="{ on }">
                    <v-btn
                      x-small
                      elevation="0"
                      v-on="on"
                      color="#f9b418"
                      @click="toggleEditDescription"
                    >
                      <span v-if="unit.description && unit.description !== ''">
                        <i class="fa fa-pencil mr-1" /> Edit
                      </span>
                      <span v-else>Add Description</span>
                    </v-btn>
                  </template>
                  <span> Click to Edit Description </span>
                </v-tooltip>
              </p>
              <template v-else>
                <v-textarea
                  v-model="unit.description"
                  name="description"
                  label="Description"
                  outlined
                  clearable
                />
                <div class="mt-2">
                  <v-btn
                    :loading="isLoading"
                    :disabled="isLoading"
                    x-small
                    color="success"
                    class="ml-1"
                    @click="quickUpdate"
                  >
                    Save
                  </v-btn>
                  <v-btn
                    :loading="isLoading"
                    :disabled="isLoading"
                    x-small
                    class="ml-1"
                    @click="toggleEditDescription"
                  >
                    cancel
                  </v-btn>
                </div>
              </template>
            </div>
            <v-menu open-on-hover top offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn text small color="primary" dark v-bind="attrs" v-on="on">
                  <v-icon right dark class="m-1">fal fa-download</v-icon>
                  Downloadable Files
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, index) in downloadLinks"
                  :key="index"
                  :href="item.link"
                  target="_blank"
                >
                  <v-list-item-title>
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-menu>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" text small>
                  <v-icon class="mr-2">fal fa-list-ul</v-icon>
                  More Options
                </v-btn>
              </template>

              <v-list>
                <v-list-item>
                  <v-btn
                    dark
                    small
                    outlined
                    color="grey darken-3"
                    @click.stop="showShareUnit = true"
                    text
                  >
                    <v-icon class="mr-2">fal fa-share-alt</v-icon>
                    Share
                  </v-btn>
                  <share-unit :unit_id="unit.id" v-model="showShareUnit" />
                </v-list-item>
                <v-list-item>
                  <v-btn
                    dark
                    small
                    outlined
                    color="grey darken-3"
                    @click.stop="showAssignUnit = true"
                    text
                  >
                    <v-icon class="mr-2">fal fa-users-cog</v-icon>
                    Assign
                  </v-btn>
                  <AssignUnit
                    :unit_id="unit.id"
                    v-model="showAssignUnit"
                    :dealers="dealers"
                  />
                </v-list-item>
                <v-list-item>
                  <v-btn
                    dark
                    small
                    outlined
                    color="grey darken-3"
                    @click.stop="showUnitPlaylist = true"
                    text
                  >
                    <v-icon class="mr-2">fal fa-layer-plus</v-icon>
                    Add to Playlist
                  </v-btn>
                  <unit-playlist :unit="unit" v-model="showUnitPlaylist" />
                </v-list-item>
              </v-list>
            </v-menu>
            <v-card
              ref="quiz-question"
              id="quiz-question"
              color="grey lighten-4"
              flat
              class="pa-4 text-left mt-3"
              v-if="quiz !== null && quizResult == null"
            >
              <v-card class="px-5 py-4">
                <v-row
                  v-for="(question, index) in quiz.questions"
                  v-bind:key="question.id"
                >
                  <v-col>
                    <h4>{{ question.value }}</h4>
                    <div
                      v-for="answer in question.answers"
                      v-bind:key="answer.id"
                    >
                      <div class="form-check mb-2">
                        <input
                          class="form-check-input"
                          :type="question.is_multiple ? 'checkbox' : 'radio'"
                          :name="index"
                          :value="answer.id"
                          @click="selectAnswer(answer.id, question.id)"
                          :id="answer.id"
                        />
                        <label class="form-check-label" :for="answer.id">{{
                          answer.value
                        }}</label>
                      </div>
                    </div>
                  </v-col>
                </v-row>
                <v-row justify="end">
                  <v-btn
                    id="unit-page__submit"
                    text
                    color="primary"
                    :loading="loadingMark"
                    @click="checkIfFinished"
                    >Submit
                  </v-btn>
                </v-row>
              </v-card>
            </v-card>
            <v-card
              id="quiz-completed"
              ref="quiz-completed"
              color="grey lighten-4"
              flat
              class="pa-4 text-left mt-3"
              v-else-if="quizResult"
            >
              <v-card-title>Quiz</v-card-title>
              <v-card class="px-5 py-4">
                <v-row
                  v-for="question in quizResultForm"
                  v-bind:key="question.id"
                >
                  <v-col>
                    <h4>{{ question.value }}</h4>
                    <div
                      v-for="(answer, index) in question.answers"
                      v-bind:key="answer.id"
                    >
                      <div class="form-check m-2">
                        <input
                          class="form-check-input"
                          :type="question.is_multiple ? 'checkbox' : 'radio'"
                          :name="index"
                          :checked="
                            isUserAnswer(question.user_answer, answer.id)
                          "
                          :value="answer.id"
                          disabled
                          @click="selectAnswer(answer.id, question.id)"
                          :id="answer.id"
                        />
                        <label
                          class="form-check-label"
                          :for="answer.id"
                          :class="
                            answer.is_correct ? 'text-success' : 'text-danger'
                          "
                          >{{ answer.value }}</label
                        >
                      </div>
                    </div>
                  </v-col>
                </v-row>
                <v-row justify="end">
                  <v-btn
                    id="unit-page__submit"
                    text
                    color="primary"
                    v-if="loadingMark"
                    :loading="loadingMark"
                    >Submit
                  </v-btn>
                </v-row>
                <v-row>
                  <v-col>
                    TOTAL SCORE: {{ quizResult.total_score }} /
                    {{ quizResult.total_number_of_questions }}
                  </v-col>
                </v-row>
              </v-card>
            </v-card>
          </div>

          <v-btn
            v-if="quiz === null || !isAVideoTypeUnit"
            color="primary"
            :disabled="isCompleted"
            :loading="loadingMark"
            @click="checkIfFinished"
            text
          >
            {{ !isCompleted ? 'Mark as Completed' : 'Completed' }}
          </v-btn>

          <notes id="unit-page__note" :unit-id="$route.params.id"> </notes>
        </div>
      </div>
    </div>
    <confirm-dialog
      :close-dialog="toggleConfirmDialog"
      :confirm-action="submit"
      :show-dialog="showConfirmDialog"
      :loading="loadingMark"
    >
      You haven't finished watching the video are you sure to mark this as
      completed?
    </confirm-dialog>
    <confirm-dialog
      :close-dialog="closeEdits"
      :confirm-action="toggleAddToLibraryDialog"
      :show-dialog="showUnassignedDialog"
      :loading="loadingMark"
    >
      This unit seems to be un-categorized. <br />Do you want to
      <strong>assign</strong> into Library?
    </confirm-dialog>
    <add-to-library-dialog
      v-on:fetch-units="reloadUnitPage"
      :key="key"
      v-model="addToLibraryDialog"
      :unit="unit"
      :self-assign="true"
    />
  </div>
</template>

<script>
import { debounce as _debounce } from 'lodash-es';
import ShareUnit from '../dialog-box/ShareUnit.vue';
import AssignUnit from '../dialog-box/AssignUnit.vue';
import UnitPlaylist from '../dialog-box/UnitPlaylist.vue';
import Notes from './Notes.vue';
import ConfirmDialog from '@/components/dialogs/ConfirmDialog';
import AddToLibraryDialog from '@/components/dialogs/AddToLibraryDialog';
import EventBus from '@/plugins/eventBus';
import {
  filter as _filter,
  find as _find,
  findIndex as _findIndex,
  forOwn as _forOwn,
  isEmpty as _isEmpty,
  each as _each,
  some as _some,
  forEach as _forEach,
} from 'lodash-es';

export default {
  name: 'UnitMain',

  props: {
    unit: Object,
  },

  components: {
    ConfirmDialog,
    Notes,
    ShareUnit,
    AssignUnit,
    UnitPlaylist,
    AddToLibraryDialog,
  },

  data: () => ({
    isLoading: false,
    editTags: false,
    editDescription: false,
    editTitle: false,
    showToolTip: true,
    showConfirmDialog: false,
    loadingMark: false,
    isFetching: false,
    showShareUnit: false,
    showAssignUnit: false,
    showUnitPlaylist: false,
    quizDialog: false,
    modprog: 78,
    answers: [],
    player: null,
    vPlayer: null,
    quizAnswered: false,
    downloadLinks: [
      {
        title: 'Salesbook',
        link: 'https://docs.google.com/document/d/1yXDXBMDhBqxUrh_n2AWlAUtIYPOSFCCbPgtn74jOdsw/edit?usp=sharing',
      },
      {
        title: 'Call Guides',
        link: 'https://docs.google.com/presentation/d/1HEhwl-N4R8zf1gNiNhV_xxOo5uCj2qlM0R8b7tG-2fk/edit?usp=sharing',
      },
      {
        title: 'File Manager',
        link: 'https://file.webinarinc.com/',
      },
    ],
    unitProgress: [
      {
        type: 'videoWatched',
        title: 'Watched the Video',
        description: 'you will be scored once you played the video',
        checked: false,
        hide: false,
      },
      {
        type: 'videoCompleted',
        title: 'Finished the Video',
        description:
          'you will be scored once you finished watching the whole video',
        checked: false,
        hide: false,
      },
      {
        type: 'quizCompleted',
        title: 'Answered the Quiz',
        description: 'you will be scored once you answered the provided quiz',
        checked: false,
        hide: false,
      },
      {
        type: 'completedUnit',
        title: 'Completed the Unit',
        description: 'you will be scored once you mark the unit as completed',
        checked: false,
        hide: true,
      },
    ],
    dealers: [],
    key: 0,
    addToLibraryDialog: false,
    saveTags: [],
    debounce: null,
    showUnassignedDialog: false,
  }),

  mounted() {
    this.getDealers();

    if ((this.isAdmin || this.isManager) && !this.unit.series) {
      this.toggleUnassignedDialog();
    }

    EventBus.$on('finishedVideo', (unit) => {
      this.unit.is_finished_watching = true;
      this.markAsCompleted();
    });

    EventBus.$on('nextUnit', () => {
      this.next();
    });
  },
  computed: {
    user() {
      return this.$auth.user();
    },

    isAdmin() {
      return _some(this.$auth.user().roles, { name: 'super-administrator' });
    },

    isManager() {
      return _some(this.$auth.user().roles, { name: 'account-manager' });
    },

    isAVideoTypeUnit() {
      return this.unit.content.search('iframe') < 0 ? false : true;
    },
    tags() {
      return this.unit.tags;
    },
    contents() {
      return this.playerFullscreen(this.unit.content);
    },
    quiz() {
      return this.unit.quiz;
    },
    quizResult() {
      return this.$store.state.clientUnit.quizResult;
    },
    quizResultForm() {
      return this.quizResult ? JSON.parse(this.quizResult.quiz_form) : null;
    },
    userId() {
      return this.$auth.user().id;
    },
    isCompleted() {
      const unitCompleted = _find(this.unitProgress, { type: 'completedUnit' });
      if (unitCompleted.checked) {
        return true;
      }

      return (
        this.$store.state.clientUnit.selectedItem.is_completed === 1 ||
        this.$store.state.clientUnit.selectedItem.is_completed === true
      );
    },
    unitProgressRender() {
      const filtered = _filter(this.unitProgress, { hide: false });

      return _forOwn(filtered);
    },
    played: {
      get() {
        const watchedIndex = 0;
        return this.unitProgress[watchedIndex].checked;
      },
      set() {
        this.checkUnitProgress('videoWatched');
      },
    },
    loadTags() {
      return this.$store.state.units.tags;
    },
  },

  created() {
    window.scrollTo(0, 0);

    if (this.loadTags.length <= 0) {
      console.log('fetching tags');
      this.$store.dispatch('units/fetchTags').then(({ data }) => {
        this.$store.commit('units/setTags', data);
      });
    }
  },

  methods: {
    toggleUnassignedDialog() {
      this.showUnassignedDialog = true;
    },
    goToModule(id) {
      this.$router.push({
        name: 'CertificationModulePage',
        params: {
          id,
        },
      });
    },
    quickUpdate() {
      this.isLoading = true;
      _forEach(this.unit.tags, (tag) => {
        typeof tag === 'object'
          ? this.saveTags.push(tag.id)
          : this.saveTags.push(tag);
      });

      this.axios
        .patch('client/lms/quickupdate/unit', {
          id: this.unit.id,
          name: this.unit.name,
          description: this.unit.description,
          quiz_id: this.unit.quiz_id,
          tags: this.saveTags,
        })
        .then((response) => {
          this.$notify('success', `${this.unit.name} updated!`);
        })
        .finally((data) => {
          this.saveTags = [];
          this.closeEdits();
        });
    },
    closeEdits() {
      this.editTitle = false;
      this.editTags = false;
      this.editDescription = false;
      this.addToLibraryDialog = false;
      this.isLoading = false;
      this.showUnassignedDialog = false;
    },
    toggleEditTitle() {
      this.editTitle = !this.editTitle;
    },
    toggleEditTags() {
      this.editTags = !this.editTags;
    },
    toggleEditDescription() {
      this.editDescription = !this.editDescription;
    },
    forceRerender() {
      this.key += 1;
    },
    toggleAddToLibraryDialog() {
      this.showUnassignedDialog = false;
      this.forceRerender();
      this.addToLibraryDialog = !this.addToLibraryDialog;
    },
    reloadUnitPage() {
      EventBus.$emit('RELOAD_UNIT_PAGE');
    },
    canEdit(company_id) {
      if (this.isAdmin) {
        return true;
      }

      if (this.isManager) {
        return this.user.dealer_id == company_id;
      }

      return false;
    },
    checkIfFinished() {
      if (this.unit.is_finished_watching) {
        this.submit();
      } else {
        this.toggleConfirmDialog();
      }
    },
    submit() {
      if (!this.unit.quiz) {
        this.markAsCompleted();
      } else {
        this.submitQuiz();
      }
      this.showConfirmDialog = false;
    },
    toggleConfirmDialog() {
      this.showConfirmDialog = !this.showConfirmDialog;
    },
    playerFullscreen(str) {
      let isVimeo = str.search('vimeo') < 0 ? false : true;
      let ret =
        str.substring(0, str.search('iframe') + 7) +
        'id="unit-video-' +
        this.unit.id +
        '" allowfullscreen="allowfullscreen" ' +
        str.substring(str.search('iframe') + 7, str.length);

      return isVimeo ? ret : str;
    },
    isQuizAlreadyAnswered() {
      this.axios
        .get(`/client/lms/quiz/${this.unit.quiz_id}`, {
          params: {
            unit_id: this.unit.id,
          },
        })
        .then(({ data }) => {
          this.$store.commit('clientUnit/setQuizResult', data.data);
        })
        .catch((error) => {
          this.$store.commit('clientUnit/setQuizResult', null);
        });
    },

    selectAnswer(answerId, questionId) {
      const answer = {
        questionId,
        answerId,
      };

      const existingIndex = _findIndex(this.answers, answer);

      if (existingIndex === -1) {
        return this.answers.push(answer);
      }

      return this.answers.splice(existingIndex, 1);
    },

    isUserAnswer(userAnswersId, currentAnswerId) {
      return userAnswersId.includes(currentAnswerId);
    },

    submitQuiz() {
      if (_isEmpty(this.answers) && this.unit.quiz) {
        this.showConfirmDialog = false;
        return this.$swal({
          title: 'Unit Completion Failed!',
          text: 'Please answer the quiz first!',
          icon: 'warning',
        });
      }

      this.loadingMark = true;
      this.axios
        .post('client/lms/quiz', {
          answers: this.answers,
          unit_id: this.unit.id,
        })
        .then(() => {
          this.quizAnswered = true;
          this.isQuizAlreadyAnswered();
          this.markAsCompleted();
        })
        .finally(() => {
          this.quizAnswered = true;
        });
    },

    markAsCompleted() {
      this.loadingMark = true;
      this.$store
        .dispatch('markAsCompleted/markAsCompleted', {
          playlistId: this.$route.params.playlistId,
          type: this.$store.state.markAsCompleted.type,
          unitId: this.$store.state.markAsCompleted.current_unit.id,
        })
        .then(({ data }) => {
          if (this.unit.series && this.unit.module) {
            this.$store.commit(
              'relatedUnits/setIsCompletedToTrue',
              this.$store.state.markAsCompleted.current_unit.id
            );
          }
          this.$store.commit('markAsCompleted/setIsCompleted', true);
          this.$store.commit('clientUnit/setCompleted', true);
          this.loadingMark = false;
          this.$emit('complete-unit');
          this.showConfirmDialog = false;
        });
    },
    addToFavoriteDialog() {
      this.$swal({
        text: 'Successfully added to Favorite list.',
        icon: 'success',
      });
    },
    next() {
      if (this.$route.params.playlistId) {
        return this.navigateAroundPlaylist('next');
      }
      return this.axios
        .post('client/lms/related-units', {
          unitId: this.unit.id,
          type: 'single',
          action: 'next',
        })
        .then(({ data }) => {
          if (data !== null) {
            return this.$router.push({
              name: 'UnitPage',
              params: {
                id: data,
              },
            });
          }

          return this.$notify('warning', 'This is the last unit in the list.');
        });
    },
    previous() {
      const { type } = this.$store.state.relatedUnits;
      if (type === 'playlist') {
        return this.navigateAroundPlaylist('back');
      }
      return this.axios
        .post('client/lms/related-units', {
          unitId: this.unit.id,
          type: 'single',
          action: 'prev',
        })
        .then(({ data }) => {
          if (data !== null) {
            return this.$router.push({
              name: 'UnitPage',
              params: {
                id: data,
              },
            });
          }

          return this.$notify('warning', 'This is the first unit in the list.');
        });
    },
    navigateAroundPlaylist(type) {
      if (type === 'back') {
        const prevId = this.$store.getters[
          'relatedUnits/getPrevUnitInPlaylist'
        ](this.unit.id);

        if (Number.isInteger(prevId)) {
          return this.$router.push({
            name: 'PlaylistUnitPage',
            params: {
              id: prevId,
              playlistId: this.$route.params.playlistId,
            },
          });
        }

        return this.$notify('warning', 'This is the first unit in the list.');
      }

      const nextId = this.$store.getters['relatedUnits/getNextUnitInPlaylist'](
        this.unit.id
      );

      if (Number.isInteger(nextId)) {
        return this.$router.push({
          name: 'PlaylistUnitPage',
          params: {
            id: nextId,
            playlistId: this.$route.params.playlistId,
          },
        });
      }

      return this.$notify('warning', 'This is the last unit in the list.');
    },
    hideVideoUnitProgressTasks() {
      const tasks = _forOwn(this.unitProgress);
      const quizCompletedTask = _find(this.unitProgress, {
        type: 'quizCompleted',
      });

      tasks.forEach((item, index) => {
        let value = item.type !== 'completedUnit';

        // if quiz exist in this unit, skip hide of quiz
        if (item.type === 'quizCompleted' && !item.hide) {
          value = false;
        }

        // if item is a "completedUnit" and
        // quiz exist in this unit, hide this item
        if (item.type === 'completedUnit' && !quizCompletedTask.hide) {
          value = true;
        }

        this.unitProgress[index].hide = value;
      });
    },
    getDealers() {
      this.$http
        .get('/dealers')
        .then((response) => {
          _each(response.data, (dealer) => {
            this.dealers.push(dealer);
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
.editor, .output {
  height: 10rem;
}


         .description {
           margin: auto;
         }

         .kt-portlet__head-title {
           font-size: 1.5rem!important
         }

#unitTitle {
  font-size: 1.8rem!important
}


.embed-container {
  position: relative;
  overflow: hidden;
  max-width: 100%;
  min-height: 0 ;
}

.embed-container >>> iframe,
.embed-container >>> object,
.embed-container >>> embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}


.embed-container.embed-padding-bottom {
  padding-bottom: 56.25%;
}
.pointer {
  cursor: pointer;
}
</style>
